
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-sale/[range]",
      function () {
        return require("private-next-pages/for-sale/[range]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-sale/[range]"])
      });
    }
  